/**
* @desc this file contains the @func of LINK_SET_TOKEN and LINK_E_VOUCHERS
* SetPassword
*/

import React, { PureComponent, Fragment } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Flex, Box } from 'grid-styled';

import { AppWrappperHOC } from '../Root/HOC';
import { selectUpdateRespopnse, select_isBoolean } from './selectors';
import { updatePassword } from './actions';
import Container from '../../components/Container';
import WhiteBackground from '../../components/WhiteBackground';
import Breadcumb from '../../components/Breadcrumb';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { utils, constants, validations, eventTracking } from '../../devUtils';
// import { rootApiResponse } from '../HeaderContainer/actions';
import Loader from '../../components/Loader';
import { activateEvoucher, submitEVoucherOtp } from '../MyEGiftCards/actions';
import { select_eVoucherJS } from '../MyEGiftCards/selectors';
import ReactTableWrapper from '../../components/ReactTableWrapper';
import Item from '../MyEGiftCards/item';
import Details from '../MyEGiftCards/details';
import Value from '../MyEGiftCards/value';
import { CUSTOMER_SUPPORT } from '../ThankYou';
import { displayLoginFrom } from '../LoginPage/actions';
import ValidationErrors from '../../components/ValidationErrors';

const columns = [{
  Header: 'Item',
  accessor: 'product',
  headerStyle: { textAlign: 'left' },
  Cell: (props) => <Item data={props} />,
  minWidth: 150,
},
{
  Header: 'Voucher Number',
  accessor: 'code',
  headerStyle: { textAlign: 'left' },
  minWidth: 145,
},
{
  Header: 'Order Details',
  accessor: 'order',
  minWidth: 300,
  headerStyle: { textAlign: 'left' },
  Cell: (props) => <Details data={props} />,
},
{
  Header: 'PIN Number',
  accessor: 'pin',
  headerStyle: { textAlign: 'left' },
},
{
  Header: 'Valid Till',
  accessor: 'expiry',
  headerStyle: { textAlign: 'left' },
  Cell: (props) => <span className="number">{utils.formattedDate(props.value)}</span>, // eslint-disable-line react/prop-types
},
{
  Header: 'Value',
  accessor: 'value',
  headerStyle: { textAlign: 'left' },
  Cell: (props) => <Value data={props} />,
}];

class EmailVerification extends PureComponent {
  constructor(props) {
    super(props);
    const { match: { params: { linkToken } } = {}, eVoucherOtpSubmit, isLoadingStatus } = props;
    this.state = {
      paramsData: {},
      passwords: {},
      isLoadingStatus,
      otpVerified: false,
      otpMessage: '',
      eVoucherResposne: {},
      eVoucherOtpSubmit,
      isShowValidation: false,
    };
    this.validators = validations;
    this.stateLessKeys = { linkToken };
    this.handleActions = this.handleActions.bind(this);
    this.handleVerifyOtp = this.handleVerifyOtp.bind(this);
    this.sendEvoucherOtp = this.sendEvoucherOtp.bind(this);
    this.submitEVoucherOtp = this.submitEVoucherOtp.bind(this);
    this.onLoginClick = this.onLoginClick.bind(this);
    this._updateValidators = this._updateValidators.bind(this);
  }

  /**
   * @function React lifeCycle
   * @function isRedirectedReq @desc check the pre-condition
   * @todo remove the dependency of paramsData and use @func parseQueryString to do the same
   */
  componentWillMount() {
    const { location = {}, location: { pathname } } = this.props;
    utils.isRedirectedReq(location);
    const data = utils.parseQueryString(location.search);
    this.setState({ paramsData: data });
    if (pathname !== constants.LINK_SET_TOKEN) {
      this.sendEvoucherOtp();
    }
    const { email } = data;
    const emailDomain = email ? email.split('@') : [];
    const baseDomain = emailDomain && emailDomain.length === 2 ? emailDomain[1].split('.') : [];
    if (baseDomain && baseDomain.length === 2 && ((baseDomain[0].toLowerCase() === 'gvkbio') || (baseDomain[0].toLowerCase() === 'soffice'))) {
      utils.isRedirectedReq({ pathname: location.pathname, search: location.search, platform: 'save' });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { updateResponse, eVoucherResposne, eVoucherOtpSubmit, isLoadingStatus } = nextProps;
    if (!utils.isEqual(this.props.updateResponse, nextProps.updateResponse)) {
      // if platform is of propel redirect to propel
      const { paramsData: { platform } } = this.state;
      utils.isRedirectedReq({ platform });
      this.setState({ isLoadingStatus, otpMessage: updateResponse, otpVerified: true });
    } else if (!utils.isEqual(this.props.eVoucherResposne, eVoucherResposne)) {
      this.setState({ isLoadingStatus, eVoucherResposne });
    } else if (!utils.isEqual(this.props.eVoucherOtpSubmit, eVoucherOtpSubmit)) {
      this.setState({ isLoadingStatus, eVoucherOtpSubmit });
    } else {
      this.setState({ isLoadingStatus });
    }
  }

  componentWillUnmount() {
    this.validators = utils.resetValidators(this.validators);
  }

  onLoginClick() {
    const { history } = this.props;
    utils.forceRedirect(history, { pathname: constants.LINK_HOME });
    eventTracking.triggerEvent('Login', 'Login Click', constants.LINK_SET_TOKEN);
    this.props.onChangeLoginModalDisplay(true);
  }

  /**
   * @desc @constant sending OTP request
   */
  sendEvoucherOtp() {
    const { linkToken: token } = this.stateLessKeys;
    this.props.onActivateEvoucher({ token });
  }

  handleActions(key, value) {
    const { passwords } = this.state;
    const data = JSON.parse(JSON.stringify(passwords));
    data[key] = value;
    this.setState({ passwords: data });
  }

  handleVerifyOtp() {
    const { passwords, paramsData: { email, phone, token } } = this.state;
    if (utils.isFieldRequired(this.validators, ['password', 'confirmPassword'])) {
      this.setState({ isShowValidation: true });
    } else {
      this.setState({ isShowValidation: false });
      const payload = {
        email, phone, token, password: passwords.password,
      };
      this.props.onUpdatePassword(payload);
    }
    // if (passwords.password === passwords.cnfrmPassword) {
    // } else {
    //   this.props.onTriggerAlert(utils.errorResponse('api', 'Password Needs to match'));
    // }
  }

  submitEVoucherOtp() {
    const { eVoucherOtp: code, linkToken: id } = this.stateLessKeys;
    this.props.onSubmitEVoucherOtp({ code, id });
  }

  _updateValidators(type, value) {
    const { passwords: { password } } = this.state;
    if (type === 'confirmPassword') {
      this.validators = utils.updateValidators(this.validators, type, value, { password });
    } else {
      this.validators = utils.updateValidators(this.validators, type, value);
    }
  }

  renderResetOtpForm() {
    const { paramsData: { email, phone }, otpVerified, otpMessage, isShowValidation, passwords: { password, confirmpassword } } = this.state;
    return (
      <Fragment>
        {
          !otpVerified ? (
            <div>
              <h3>Set your password below to create a new Zaggle Account</h3>
              <p><b>Email:</b> <span>{email}</span></p>
              <p><b>Mobile:</b> <span>{phone}</span></p>
              <Flex flexWrap="wrap">
                <Box w={[12 / 12, 3 / 12]} >
                </Box>
                <Box w={[12 / 12, 6 / 12]} >
                  <Flex flexWrap="wrap">
                    <Box w={[12 / 12, 4 / 12]} >
                      <Input
                        type="password"
                        placeholder="Enter new Password"
                        required
                        onChange={
                          (e) => {
                            this.handleActions('password', e.target.value);
                            this._updateValidators('password', e.target.value);
                          }
                        }
                        maxLength={15}
                        value={password}
                      />
                      {isShowValidation && ValidationErrors(this.validators, 'password')}
                    </Box>
                    <Box w={[12 / 12, 4 / 12]}>
                      <Input
                        type="password"
                        placeholder="Confirm Password"
                        required
                        onChange={(e) => {
                          this.handleActions('cnfrmPassword', e.target.value);
                          this._updateValidators('confirmPassword', e.target.value);
                        }}
                        value={confirmpassword}
                      />
                      {isShowValidation && ValidationErrors(this.validators, 'confirmPassword')}
                    </Box>
                    <Box w={[12 / 12, 4 / 12]}>
                      <div className="lg-none"><br /><br /></div>
                      <Button type="primary" onClick={this.handleVerifyOtp}>Update</Button>
                    </Box>
                  </Flex>
                </Box>
                <Box w={[12 / 12, 3 / 12]} >
                </Box>
              </Flex>
            </div>
          ) : (
            <div>
              <h3>{otpMessage.message}</h3>
              <Button type="primary" onClick={this.onLoginClick}>Login</Button>
            </div>
          )
        }
      </Fragment>
    );
  }

  /**
   * @description rendering Table is OTP is Success
   */
  renderEVoucherForm() {
    const { paramsData: { phone }, eVoucherResposne, eVoucherOtpSubmit } = this.state;
    if (!eVoucherOtpSubmit.length) {
      return (
        <React.Fragment>
          <br />
          <span>An OTP has been sent to the mobile number {phone}. Please enter it below to view the e-Gift Card details</span><br /><br /><br />
          <Input
            onChange={(evt) => { this.stateLessKeys.eVoucherOtp = evt.target.value; }}
            type="text"
            placeholder="Enter OTP"
          /><br /><br />
          <Button type="primary" onClick={this.submitEVoucherOtp}>Submit</Button><br /><br /><br />
          <span className="links left" role="presentation" onClick={this.sendEvoucherOtp}>Not received OTP? Resend OTP</span><br /><br />
          {CUSTOMER_SUPPORT()}
        </React.Fragment>
      );
    }
    return (<ReactTableWrapper
      data={eVoucherOtpSubmit}
      columns={columns}
      showPageJump={false}
      showPagination={false}
      pageSize={eVoucherOtpSubmit.length}
    />);
  }

  render() {
    const { match: { path } = {} } = this.props;
    const { isLoadingStatus } = this.state;
    if (isLoadingStatus) {
      return <Loader />;
    }
    return (
      <Container>
        <Breadcumb />
        <WhiteBackground className="text-center">
          {path === constants.LINK_SET_TOKEN ? this.renderResetOtpForm() : this.renderEVoucherForm()}
        </WhiteBackground>
      </Container>
    );
  }
}

EmailVerification.propTypes = {
  location: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({}).isRequired,
  // onTriggerAlert: PropTypes.func,
  onUpdatePassword: PropTypes.func.isRequired,
  updateResponse: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({}).isRequired,
  onActivateEvoucher: PropTypes.func.isRequired,
  eVoucherResposne: PropTypes.shape({}).isRequired,
  onSubmitEVoucherOtp: PropTypes.func.isRequired,
  eVoucherOtpSubmit: PropTypes.array.isRequired,
  isLoadingStatus: PropTypes.bool.isRequired,
  onChangeLoginModalDisplay: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  // onTriggerAlert: (payload) => dispatch(rootApiResponse(payload)),
  onUpdatePassword: (payload) => dispatch(updatePassword(payload)),
  onActivateEvoucher: (payload) => dispatch(activateEvoucher(payload)),
  onSubmitEVoucherOtp: (payload) => dispatch(submitEVoucherOtp(payload)),
  onChangeLoginModalDisplay: (payload) => dispatch(displayLoginFrom(payload)),
});

const mapStateToProps = createStructuredSelector({
  updateResponse: selectUpdateRespopnse(),
  eVoucherResposne: select_eVoucherJS('eVoucherActivate'),
  eVoucherOtpSubmit: select_eVoucherJS('otpSuccess'),
  isLoadingStatus: select_isBoolean('isLoading'),
});

const component = connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(EmailVerification));
export default component;



// WEBPACK FOOTER //
// client/containers/EmailVerification/index.js